import { useRef, useEffect } from 'react';
import './Home.css';
import logo from '../../images/phoenix-unity-designs-transparent-light.svg';
import checkMark from '../../images/check-mark.svg';
import codeVideoWebm from '../../images/coding.webm';
import codeVideoMp4 from '../../images/coding.mp4';
import { isIOS, checkIfInView } from '../../utils';
import { Link } from "react-router";
import Testimonials from '../../components/Testimonials';
import { chevronDown } from '../../images/SVGs';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getOrganizationSchema, DOMAIN_URL } from '../../config/seo';

function Home() {
  const logoRef = useRef()
  const videoRef = useRef()
  const thirdBlockRowRef = useRef()
  
  useEffect(() => {
    document.title = 'Phoenix Unity Designs - Your Next Impression Starts Here';
    videoRef?.current?.play()
    
    checkIfInView(thirdBlockRowRef)
    checkIfInView(logoRef)
    const handleScroll = () => {
      checkIfInView(thirdBlockRowRef)
      checkIfInView(logoRef)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [])

  const scrollDown = () => {
    const scrollBy = window.innerHeight
    window.scroll({
      top: scrollBy,
      left: 0,
      behavior: 'smooth'
    })
  }

  return (
    <div className="Home">
      <SEOHead
        title={SEO_CONFIG.home.title}
        description={SEO_CONFIG.home.description}
        keywords={SEO_CONFIG.home.keywords}
        canonical={DOMAIN_URL}
        ogUrl={DOMAIN_URL}
        structuredData={getOrganizationSchema()}
      />
      <header className="Home-header">
        <img src={logo} className="phoenix-logo image-fade-in" alt="Phoenix Unity Designs" ref={logoRef} />
        <h1 className="tagline">
          Your next impression starts here.
        </h1>
        <button
          className="down-button"
          aria-label="Scroll down to explore"
          onClick={scrollDown}
        >
          {chevronDown}
        </button>
      </header>
      <main id="main-content" tabIndex="-1">
        <div className='video-wrapper'>
          {!isIOS() && <video preload="auto" autoPlay="" muted loop width="1800" height="700" ref={videoRef}>
            <source type="video/webm" src={codeVideoWebm} />
            <source type="video/mp4" src={codeVideoMp4} />
          </video>}
          <div className="home-block first-block">
            <div className="container">
              <div className="row">
                <div className="col">
                  We speak business, not just code.<br />
                  We'll guide you through every step.
                  <div className='text-center mt-3'>
                    <Link to="/our-process" className="btn btn-primary btn-accent" anim="sheen">Our Process &raquo;</Link>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home-block second-block">
          <div className="container">
            <div className="row">
              <div className="col">
                15+ years of experience building web solutions that actually work.
              </div>
            </div>
          </div>
        </div>
        <div className="home-block third-block">
          <div className="container" ref={thirdBlockRowRef}>
            <div className="row">
              {/* <div className="col"> */}
              <div className="col-lg-8 offset-lg-4 text-fade-in">
                <h2>What we do</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 order-2 order-lg-1 check-mark-parent">
                <img src={checkMark} className="check-mark" alt="Check mark" />
              </div>
              <div className="col-lg-8 order-1 order-lg-2 text-fade-in">
                {/* <span>Challenging convention to reveal opportunity and build brands with purpose.</span> */}
                <ul>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> Website Design & Development</li>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> Web Application Design & Development</li>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> Branding & Identity</li>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> Graphic Design</li>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> IT Services</li>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> Photography</li>
                  <li><img src={checkMark} className="check-mark" alt="Check mark" /> Video Editing</li>
                </ul>
                <p className='services-tagline'>All with a focus on quality, reliability, and clear communication.</p>
                {/* <span>No fluff,</span><br /><span>no “agency overhead”,</span><br /><span>just high-quality, reliable work.</span> */}
              </div>
            </div>
          </div>
        </div>
        <div className="home-block fourth-block">
          <div className="container">
            <div className="row">
              <div className="col">
                Ready to see what your next website could be?
                <br /><Link to='/contact' className="btn btn-primary btn-accent" anim="sheen">Reach out  &raquo;</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="home-block fifth-block">
          <Testimonials />
        </div>
      </main>
    </div>
  );
}

export default Home;
